import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { updateGroupItemFailure, updateGroupItemSuccess } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* updateGroupItem({ payload: { data: payload, cb } }) {
  const url = `${API_BASE_URL}/application-group-items/${payload.id}`;
  const groupItemData = {
    enabled: payload.enabled,
    groupId: payload.group.id,
    name: payload.name,
  };

  const response = yield request({
    method: 'put',
    data: groupItemData,
    url,
  });
  if (response.success) {
    yield put(updateGroupItemSuccess(payload));
    Notify('Group Item Updated Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    yield put(
      updateGroupItemFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    const errorMesssage = response.statusCode === 409 ? 'Group item already exists' : response.message;

    networkErrorHandler(response?.statusCode, errorMesssage);
  }
}

export function* onUpdateGroupItem() {
  yield takeLatest(GroupActionTypes.UPDATE_GROUP_ITEM, updateGroupItem);
}
